var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 55.5,
    fill: "#4F4F4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_62_16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 75,
    fill: "#767676",
    fillOpacity: 0.34
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.577 94.4411C98.8537 94.4411 92.674 100.602 92.674 107.922C92.6686 109.747 93.0248 111.556 93.7221 113.243C94.4193 114.93 95.4438 116.463 96.7364 117.752C98.0289 119.041 99.564 120.062 101.253 120.755C102.942 121.448 104.752 121.799 106.577 121.789C108.403 121.8 110.213 121.448 111.902 120.755C113.591 120.063 115.127 119.042 116.42 117.753C117.712 116.464 118.737 114.931 119.435 113.244C120.132 111.556 120.488 109.747 120.483 107.922C120.483 105.226 119.324 102.528 118.165 100.602L113.526 104.841C113.918 105.613 114.305 106.765 114.305 107.922C114.305 112.546 110.828 116.013 106.577 116.013C101.941 116.013 98.4666 112.546 98.4666 107.922C98.4666 103.685 101.941 100.219 106.577 100.219C107.734 100.219 108.895 100.602 110.052 100.989L114.305 96.752C112.013 95.2383 109.325 94.4344 106.577 94.4411ZM122.803 85.9647C122.411 85.9647 122.411 85.9647 122.411 86.3518L117.393 91.3583C117.008 91.7455 116.616 92.1302 116.616 92.9021L117.008 95.5953L108.121 104.456C107.734 104.456 106.964 104.069 106.577 104.069C105.418 104.069 104.262 104.456 103.49 105.226C101.944 106.763 101.944 109.465 103.49 111.007C104.262 111.774 105.421 112.159 106.577 112.159C107.349 112.159 108.506 111.774 109.282 111.007C110.441 109.85 110.828 107.922 110.052 106.38L118.937 97.5215L122.024 97.9086C122.411 97.9086 123.186 97.9086 123.57 97.5215L128.591 92.515C128.978 92.1278 128.591 91.7431 128.204 91.7431L123.57 91.356L123.186 86.3495C122.803 86.3495 122.803 85.9647 122.803 85.9647ZM106.577 84.4233C93.4458 84.4233 83.0172 95.2106 83.0172 107.922C83.0172 121.017 93.4482 131.807 106.577 131.807C119.706 131.807 130.137 121.017 130.137 107.922C130.137 103.685 128.981 99.4476 126.663 95.9801L124.342 98.2933C123.955 98.6781 123.186 99.0628 122.803 99.0628C123.955 101.761 124.729 104.844 124.729 107.922C124.729 118.326 116.616 126.413 106.577 126.413C96.1486 126.413 88.0403 118.329 88.0403 107.922C88.0403 97.9086 96.151 89.817 106.577 89.817C109.667 89.817 112.757 90.5888 115.464 92.1278C115.464 91.356 115.847 90.9736 116.232 90.5888L118.939 87.8908C115.21 85.6337 110.936 84.4349 106.577 84.4233Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_62_16",
    x: 0.6,
    y: 0.6,
    width: 212.8,
    height: 212.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7,
    result: "effect1_foregroundBlur_62_16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/T2.095d071814e8d2779c27836e4529e09e.svg";
export { ForwardRef as ReactComponent };